import { useMutation } from '@tanstack/react-query'

import { saveAdvisorDetails, updateFreshChatId } from './functions'

export function useSaveAdvisorDetails() {
  return useMutation(saveAdvisorDetails)
}

export function useUpdateFreshChatId() {
  return useMutation(updateFreshChatId)
}
